module.exports = __webpack_public_path__ + "static/media/Vector-3.a6ff2b59.svg";